export default {
  home: '首页',
  login: '登录',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown编辑器',
  editor_page: '富文本编辑器',
  icons_page: '自定义图标',
  img_cropper_page: '图片编辑器',
  update: '上传数据',
  join_page: 'QQ群',
  doc: '文档',
  update_table_page: '上传CSV文件',
  update_paste_page: '粘贴表格数据',
  multilevel: '多级菜单',
  directive_page: '指令',
  level_1: 'Level-1',
  level_2: 'Level-2',
  level_2_1: 'Level-2-1',
  level_2_3: 'Level-2-3',
  level_2_2: 'Level-2-2',
  level_2_2_1: 'Level-2-2-1',
  level_2_2_2: 'Level-2-2-2',
  excel: 'Excel',
  'upload-excel': '上传excel',
  'export-excel': '导出excel',
  tools_methods_page: '工具函数',
  drag_list_page: '拖拽列表',
  i18n_page: '多语言',
  modalTitle: '模态框题目',
  content: '这是模态框内容',
  buttonText: '显示模态框',
  'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
  error_store_page: '错误收集',
  error_logger_page: '错误日志',
  query: '带参路由',
  params: '动态路由',
  cropper_page: '图片裁剪',
  message_page: '消息中心',
  tree_table_page: '树状表格',
  org_tree_page: '组织结构树',
  drag_drawer_page: '可拖动抽屉',
  tree_select_page: '树状下拉选择器',

  user: '帐号管理',
  role: '职位管理',
  permission: '权限管理',
  customer: '客户管理',
  factory: '门店管理',
  device: '设备管理',
  order: '订单管理',
  batch: '染缸管理',
  piece: '布匹管理',
  event: '事件记录',
  customer_user: '客户用户',
  remark: '备注管理',
  finance: '财务管理',
  dy: '运营后台',
  org_confg: '基础配置',
  gpt_library: 'gpt话术库',
  classify_library: '分类库',
  action_type_library: '动作类型库',
  task_type_library: '任务类型库',
  holiday_library: '节假日祝福语',
  model_management: '模型管理',
  strategy: '运营策略',
  gpt: 'gpt配置',
  advertisement: '广告语配置',
  org: '固定话术配置',
  comment_strategy_rule: '评论私信策略',
  letter_strategy: '私信周期策略',
  comment_strategy: '标题关键词',
  comment_strategy_keyword: '评论关键词',
  strategy_task: '运营任务',
  strategy_result: '运营结果',
  dy_user_list: '运营账号列表',
  strategy_result_chart: '运营结果统计',
  strategy_result_list: '评论记录',
  customer_classify_list: '客户分类列表',
  tag_stand: '用户画像话术',
  tag: '用户画像类别',
  flower: '关注人',
  flower: '关注人',
  children_comment: '子信息',
  push_video: '发布视频',
  delete_comment_list: '被删除的评论',
  video_audio_manage: '音视频管理',
  char2Audio: '语音生成',
  start_video_task: '启动短视频',
  check_srt: '提取话术审核',
  translate_text: '翻译文本',
  covert_face_list: '视频生成',
  merge_video: '合成视频',
  translate_detail: '翻译校对界面',
  check_srt_form: '话术校对界面',
  advertisement_video: '插入广告',
  stand_user: '对标账号',
  work_type_library: '工作类型库',
  video_type_library: '视频分类库',
  scene_library: '场景库',
  make_video_detail: '生成视频步骤',
  gz_video_library: '钩子视频库',
  advertisement_video_library: '广告视频库',
  hj_video_library: '混剪视频库',
  stand_user_list: '对标账号',
  mouth_video_library: '嘴型视频库',
  music_library: '背景音乐库',
  music_library_classify: '背景音乐类型',
  server_list: '设备列表',
  device_list: '设备列表',
  video_data_views: '数据分析',
  cookie_list: 'cookie管理',
  mouth_gpt_modal: '口播gpt模版',
  soft_version_list: '软件版本'
}
